import type { ComponentType } from 'react';
import React, { Component } from 'react';
import { getDisplayName } from 'wix-rich-content-common';

export default function decorateWithComponentProps<P extends object>(
  EmbeddedComponent: ComponentType<P>,
  extraProps?: Partial<P>
): ComponentType<P> {
  return class extends Component<P> {
    static displayName = `Decorated(${getDisplayName(EmbeddedComponent)})`;

    render() {
      return <EmbeddedComponent {...this.props} {...extraProps} />;
    }
  };
}
